import { j as r } from "./index-2269cfe0.js";
import { Component as o } from "react";
class i extends o {
  constructor() {
    super(...arguments), this.state = {
      hasError: !1
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: !0
    };
  }
  componentDidCatch(t, e) {
    console.error("Uncaught error:", t, e);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ r.jsx("div", {
      children: /* @__PURE__ */ r.jsx("span", {
        color: "red",
        children: "Something went wrong."
      })
    }) : this.props.children;
  }
}
export {
  i as E
};
